export const menuItemsMobile = [
  {
    title: 'Заявки',
    icon: 'responses',
    route: '/home',
  },
  {
    title: 'Рейсы',
    icon: 'flights',
    route: '/flights-mobile',
  },
  {
    title: 'Помощь',
    icon: 'help',
    route: '/help-mobile',
  },
  {
    title: 'Профиль',
    icon: 'profile',
    route: '/profile-mobile',
  },
  {
    title: 'Еще',
    icon: 'more',
    route: '/more-items',
  },
]
